module.exports = __webpack_public_path__ + "static/media/carousel-2.b948f5f3.png";